<template>
  <router-view/>
</template>

<style>
@font-face {
  font-family: 'Gilroy';
  src: url('@/assets/fonts/Gilroy-Regular.ttf') format('opentype');
  font-weight: 400; /* Normal */
  font-style: normal;
}

@font-face {
  font-family: 'Gilroy';
  src: url('@/assets/fonts/Gilroy-SemiBold.ttf') format('opentype');
  font-weight: 600; /* ExtraBold */
  font-style: normal;
}

@font-face {
  font-family: 'Gilroy';
  src: url('@/assets/fonts/Gilroy-ExtraBold.otf') format('opentype');
  font-weight: 800; /* ExtraBold */
  font-style: normal;
}

* {
    padding: 0;
    margin: 0;    
    font-family: 'Gilroy', sans-serif;
    box-sizing: border-box; /* limita os elementos filho na medida maxima do pai, sem passar */
  }

  html, body {
    scroll-behavior: smooth; /* Ativa o scroll suave */
  }
  
::-webkit-scrollbar{
    background-color: transparent;
    width: 0.5rem;
}

::-webkit-scrollbar-thumb{
    background-color: rgb(10, 10, 90);
    border-radius: 1rem;
}
</style>
